import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../theme';
import { responsiveSmVsMd } from '../styles/responsiveMixins';

export const useAuthErrorDialogStyles = createStyles(({ token }) => ({
  authErrorDialog: {
    '&&': {
      'span.ant-typography': {
        lineHeight: '21px',
        ...responsiveSmVsMd(
          { fontSize: token.fontSizeLG },
          { fontSize: token.fontSizeHeading4 }
        ),
      },

      '.ant-row': {
        justifyContent: 'center',

        '> .ant-col': {
          width: 110,
          flex: 'initial',
        },
      },
    },
  },
  links: {
    marginTop: ThemeSpaces.SPACE_NORM_15,
    lineHeight: '23px',
    color: token.colorPrimary,
    textAlign: 'center',
    fontSize: token.fontSizeLG,
    fontWeight: 'bold',
  },
}));
